// extracted by mini-css-extract-plugin
module.exports = {"KSPPicture":"KSPPicture_KSPPicture__00JpE"};